import { render, staticRenderFns } from "./campusStudents.vue?vue&type=template&id=1c585332&scoped=true"
import script from "./campusStudents.vue?vue&type=script&lang=js"
export * from "./campusStudents.vue?vue&type=script&lang=js"
import style0 from "./campusStudents.vue?vue&type=style&index=0&id=1c585332&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c585332",
  null
  
)

export default component.exports